export function addError(errors: Record<string, string>, field: string, message: string): Record<string, string> {
  if (!errors) errors = {};

  errors[field] = message;
  return errors;
}
